module.exports = __webpack_public_path__ + "media/didi.45a71cf4.mp3";